export default __webpack_public_path__ + "static/media/UB_logotyp_2rader_cremevit_RGB.43837256.png";